module.exports = __webpack_public_path__ + "img/iPhone4.67db49fe.png";